<template>
    <div>
        <f7-list class="form-group">
            <f7-list-input
                :input-id     ="name"
                :name         ="name"
                type          ="email"
                class         =""
                :label        ="label"
                placeholder   =""
                :value        ="name == 'newEmail' ? update.tempNewEmail : update.tempConfirmNewEmail"
                @input        ="email = $event.target.value; setVal($event.target.value); validateInput($event.target)"
                autocomplete  ="off"
                outline
                floating-label
                required
                :disabled     ="isDisabled"
                :clear-button ="!isDisabled"
            ></f7-list-input>
        </f7-list>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
    props: [
        'name',
        'label',
        'theValue',
        'isDisabled',
    ],
    mounted(){
        //console.log(this.update.tempNewEmail + " ### " + this.update.tempConfirmNewEmail)
        if(this.update.tempNewEmail.trim() != "" || this.update.tempConfirmNewEmail.trim() != ""){
            this.validateInput({name: "newEmail", value: this.update.tempNewEmail})
            this.validateInput({name: "confirmEmail", value: this.update.tempConfirmNewEmail})
        }
    },
    data: function () {
        return {
            email: ''
        }
    },
    computed: {
        ...mapGetters('customer', [
            'update',
        ])
    },
    methods: {
        ...mapActions('customer', [
            'setUpdateTempNewEmail',
            'setUpdateTempConfirmNewEmail',
        ]),

        reinit(){
            console.log("re-init component")
        },

        setVal(val){
            if(this.name == "newEmail"){
                this.setUpdateTempNewEmail(val)
            }else{ // confirmEmail
                this.setUpdateTempConfirmNewEmail(val)
            }
        },

        validateInput(e){
            var regex   = /^[_a-z0-9-]+([_+.a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9]+)*(\.[a-z]{2,})$/i;
            var validate = regex.test(e.value);
            let translation="";
            if(!validate){
                if(e.value.trim() == ""){
                  if(e.name.toLowerCase() == "email"){
                    translation = this.$t('ua-email-current-empty')
                  }else if(e.name.toLowerCase() == "newemail"){
                    translation = this.$t('ua-email-new-empty')
                  }else if(e.name.toLowerCase() == "confirmemail"){
                    translation = this.$t('ua-email-confirm-empty')
                  }    
                  this.setInputState(e.name, translation);              
                }else{
                    this.setInputState(e.name, this.$t('regis-email-rule'));
                }        
            } else {
                this.setInputState(e.name, true);
            }
            //console.log("validate : "+e.name+" -> "+e.value)
            this.$emit("validateInput", {name: e.name, email: e.value, isValidate: validate });
        }
    }
}
</script>